// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";
import { makeDate, makeDateNow } from "src/lib/utils.js";

// Stateful components

export class Calendar extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            'current_date': makeDateNow()
        };

        this.onDateClick = this.onDateClick.bind(this);
    }


    //
    // Functions
    //

    onDateClick(e) {
        e.preventDefault();

        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var cell = e.target;
        var date = cell.getAttribute('data-date');

        helpers.updateSelectedDate(makeDate(date));
    }

    getTrimesterLabel() {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
        var hide_label = 'trimester';
        
        if (user_personalisation['attributes']) { 
            var current_week = user_personalisation['attributes']['CURRENT_WEEK'];
            if (current_week) {
                if (typeof current_week === 'string') {
                    current_week = [current_week];                    
                }

                return current_week.map(function(label) {
                    if(label.toLowerCase().indexOf(hide_label) === -1) {
                        return <span key={label} className="calendar__label">{label}</span>;
                    }
                });
            }
        }
        return null;
    }

    checkForEvents(comparison_date) {
        var this_component = this;
        var portal_context = this_component['context'];
        var my_schedule = portal_context['my_schedule'];
        var my_exams = portal_context['my_exams'];
        var has_event = false;
        var date_format = 'YYYY-MM-DD';

        // Check Schedule
        for (var index = 0; index < my_schedule.length; index++) {
            var current_event = my_schedule[index];
            var start_date = new Date(current_event['start']);
            var date_formatted = makeDate(start_date, date_format);

            if(date_formatted === comparison_date) {
                has_event = true;
                break;
            }
        }

        // Check Exams
        for (var index = 0; index < my_exams.length; index++) {
            var current_event = my_exams[index];
            var start_date = new Date(current_event['start']);
            var date_formatted = makeDate(start_date, date_format);

            if(date_formatted === comparison_date) {
                has_event = true;
                break;
            }
        }

        return has_event;
    }

    renderBody() {
        var this_component = this;
        var portal_context = this_component['context'];
        var selected_date = portal_context['selected_date'];
        var current_date = this_component.state['current_date'];
        var NO_OF_WEEKS = 4;

        var first_day = current_date.clone().startOf('week');
        var date_format = 'YYYY-MM-DD';

        var days = [];
        for (var d = 0; d < NO_OF_WEEKS*7; d++) {
            var date = first_day.clone().add(d, 'day');
            var day = date.format('D');
            var date_formatted = date.format(date_format);
            var date_class = "";

            var isPast = date.diff(current_date, 'day') < 0 ? true : false;
            var isToday = date.isSame(current_date, 'day');
            
            if (isPast) {
                date_class = "past";
            } else if (isToday) {
                date_class = "today"
            }

            // Check for selected day
            var selected_date_formatted = selected_date.format(date_format);
            if(date_formatted === selected_date_formatted) {
                date_class += " selected";
            }

            // Check for events
            var has_event = this_component.checkForEvents(date_formatted);
            
            if(has_event) {
                date_class += " has-event";
            }

            days.push(
                <td
                    key={d}
                    className={date_class}
                    data-date={date_formatted}
                    onClick={!isPast ? this.onDateClick : null}
                >
                    {day}
                </td>
            );

        }

        var rows = [];
        var cells = [];

        days.forEach(function(cell, i) {
            if (i % 7 !== 0) {
                cells.push(cell);
            } else {
                rows.push(cells);
                cells = [];
                cells.push(cell);
            }
            if (i === days.length - 1) {
                rows.push(cells);
              }
        });

        return rows.map(function(row, i) {
            return <tr key={i}>{row}</tr>;
        });
    }


    //
    // Render
    //


    render() {
        var this_component = this;
        var current_date = this_component['state']['current_date'];

        var header_date = current_date.format('D MMM YYYY');
        var trimester_label = this_component.getTrimesterLabel();
        var weekday_headers = moment.weekdays().map(function(day) {
            return <th key={day}>{day[0]}</th>;
        });
        var calendar_body = this_component.renderBody();

        return (
            <>
                <div className="calendar__wrapper inner" data-ga-label="Calendar">
                    <div className="calendar">
                        <div className="calendar__header">
                            <span className="calendar__date">{header_date}</span>
                            {trimester_label}
                        </div>
                        <table className="calendar__body">
                            <thead>
                                <tr>{weekday_headers}</tr>
                            </thead>
                            <tbody>
                                {calendar_body}
                            </tbody>
                        </table>
                    </div>
                </div>
                <ContextualMessage id="calendar" />
                </>
        );
    }

};

Calendar.contextType = PortalContext;
